var _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRevisaCorreo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 48C24 45.7909 25.7909 44 28 44H100C102.209 44 104 45.7909 104 48V96C104 98.2091 102.209 100 100 100H28C25.7909 100 24 98.2091 24 96V48Z",
    fill: "#EBEEF7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 48C24 45.7909 25.7909 44 28 44H100C102.209 44 104 45.7909 104 48V96C104 98.2091 102.209 100 100 100H28C25.7909 100 24 98.2091 24 96V48Z",
    fill: "url(#paint0_linear_6453_36979)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M24 48C24 45.7909 25.7909 44 28 44H100C102.209 44 104 45.7909 104 48V96C104 98.2091 102.209 100 100 100H28C25.7909 100 24 98.2091 24 96V48Z",
    fill: "#EDE7F6"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.22
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34 100L49.4977 68L62.8974 76.7692C64.236 77.6452 65.9678 77.6394 67.3005 76.7545L80.4845 68L96 100H34Z",
    fill: "#B4BACA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0758 47.2207C24.0261 47.4727 24 47.7333 24 47.9999V51.9122L63.53 77.0398C64.5286 77.6746 65.8071 77.6631 66.7941 77.0104L104 52.4065V47.9999C104 47.8727 103.994 47.7468 103.982 47.6226L65.1286 73.3163L24.0758 47.2207Z",
    fill: "#B4BACA"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8878 24.7744C94.2698 23.7419 95.7302 23.7419 96.1122 24.7744L98.6545 31.6448C98.7746 31.9694 99.0306 32.2254 99.3552 32.3455L106.226 34.8878C107.258 35.2698 107.258 36.7302 106.226 37.1122L99.3552 39.6545C99.0306 39.7746 98.7746 40.0306 98.6545 40.3552L96.1122 47.2256C95.7302 48.2581 94.2698 48.2581 93.8878 47.2256L91.3455 40.3552C91.2254 40.0306 90.9694 39.7746 90.6448 39.6545L83.7744 37.1122C82.7419 36.7302 82.7419 35.2698 83.7744 34.8878L90.6448 32.3455C90.9694 32.2254 91.2254 31.9694 91.3455 31.6448L93.8878 24.7744Z",
    fill: "#0075FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7316 11.8011C74.3513 10.974 75.2052 10.1202 76.0323 10.5005L78.7621 11.7557C79.0222 11.8753 79.3215 11.8753 79.5815 11.7557L82.3113 10.5005C83.1384 10.1202 83.9923 10.974 83.612 11.8011L82.3568 14.531C82.2372 14.791 82.2372 15.0903 82.3568 15.3504L83.612 18.0802C83.9923 18.9073 83.1384 19.7612 82.3113 19.3809L79.5815 18.1256C79.3215 18.0061 79.0222 18.0061 78.7621 18.1256L76.0323 19.3809C75.2052 19.7612 74.3513 18.9073 74.7316 18.0802L75.9869 15.3504C76.1064 15.0903 76.1064 14.791 75.9869 14.531L74.7316 11.8011Z",
    fill: "#69F0AE"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.7573,
    y: 85.9338,
    width: 8,
    height: 8,
    rx: 1,
    transform: "rotate(-45 18.7573 85.9338)",
    fill: "#A498FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6453_36979",
    x1: 62.0539,
    y1: 45.3966,
    x2: 179.368,
    y2: 277.697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEEF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.878901,
    stopColor: "#B4BACA"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevisaCorreo);
export default __webpack_public_path__ + "static/media/revisa-correo.21aa797c05bd136ba65730bd847868fd.svg";
export { ForwardRef as ReactComponent };